(() => {
  const classList = {
    menuToggleButton: 'js-header-menu-item-button',
    menuContent: 'js-header-menu-content',
    closeButton: 'js-header-menu-content-close-button',
  };

  const selectorList = {
    menuToggleButton: `.${classList.menuToggleButton}`,
    menuContent: `.${classList.menuContent}`,
    openedMenuContent: `.${classList.menuContent}[aria-hidden="false"]`,
  };

  const getToggleButtonByMenuContent = (menuContent) => {
    const targetButtonId = menuContent.getAttribute('aria-labelledby');
    if (!targetButtonId) {
      throw new Error('target button id is missing');
    }
    const targetButton = document.getElementById(targetButtonId);
    if (!targetButton) {
      throw new Error('target button element is missing');
    }
    return targetButton;
  };

  const getMenuContentByToggleButton = (button) => {
    const targetContentId = button.getAttribute('aria-controls');
    if (!targetContentId) {
      throw new Error('target content id is missing');
    }
    const targetContent = document.getElementById(targetContentId);
    if (!targetContent) {
      throw new Error('target content element is missing');
    }
    return targetContent;
  };

  const openMenuContent = (button, content) => {
    button.setAttribute('aria-expanded', 'true');
    content.setAttribute('aria-hidden', 'false');
    $('#PageContainer').addClass('blur');
    $('#lpHeader').addClass('open');
    // 背景divをblockにする
  };

  const closeMenuContent = (button, content) => {
    button.setAttribute('aria-expanded', 'false');
    content.setAttribute('aria-hidden', 'true');
    $('#PageContainer').removeClass('blur');
    $('#lpHeader').removeClass('close');

    // 背景divをnoneにする
  };

  const isMenuContentOpen = (button, content) =>
    content.getAttribute('aria-hidden') === 'false' &&
    button.getAttribute('aria-expanded') === 'true';

  const toggleButtonEventInit = () => {
    const menuToggleButtons = document.getElementsByClassName(
      classList.menuToggleButton
    );
    for (const menuToggleButton of menuToggleButtons) {
      menuToggleButton.addEventListener('mouseover', () => {
        const targetMenuContent =
          getMenuContentByToggleButton(menuToggleButton);
        //if (isMenuContentOpen(menuToggleButton, targetMenuContent)) {
        //  closeMenuContent(menuToggleButton, targetMenuContent)
        //} else {
        openMenuContent(menuToggleButton, targetMenuContent);
        //}
      });
    }
  };

  const closeButtonEventInit = () => {
    // clicking close button
    const closeButtons = document.getElementsByClassName(classList.closeButton);
    for (const closeButton of closeButtons) {
      closeButton.addEventListener('click', (event) => {
        const openedMenuContent = closeButton.closest(selectorList.menuContent);
        if (!openedMenuContent) {
          throw new Error('target content area id is missing');
        }
        const targetButton = getToggleButtonByMenuContent(openedMenuContent);
        closeMenuContent(targetButton, openedMenuContent);
      });
    }
  };

  const closeEventInit = () => {
    // clicking anywhere
    document.addEventListener('mouseout', (e) => {
      // clicking any toggle button
      if (e.target.closest(selectorList.menuToggleButton)) {
        const button = e.target.closest(selectorList.menuToggleButton);
        const menuToggleButtons = document.getElementsByClassName(
          classList.menuToggleButton
        );
        for (const menuToggleButton of menuToggleButtons) {
          if (button.id === menuToggleButton.id) {
            continue;
          }
          const targetMenuContent =
            getMenuContentByToggleButton(menuToggleButton);
          if (isMenuContentOpen(menuToggleButton, targetMenuContent)) {
            closeMenuContent(menuToggleButton, targetMenuContent);
          }
        }
        return;
      }

      // clicking anywhere except menu content
      if (!e.target.closest(selectorList.menuContent)) {
        const openedMenuContent = document.querySelector(
          selectorList.openedMenuContent
        );
        if (!openedMenuContent) {
          return;
        }
        const targetButton = getToggleButtonByMenuContent(openedMenuContent);
        closeMenuContent(targetButton, openedMenuContent);
      }
    });
  };

  window.addEventListener('DOMContentLoaded', toggleButtonEventInit);
  window.addEventListener('DOMContentLoaded', closeButtonEventInit);
  window.addEventListener('DOMContentLoaded', closeEventInit);
})();
